var React = require('react');

function CloudRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1379 1284.66a33.92 33.92 0 0 1 -4.06 16.14h-333.94a48.36 48.36 0 0 1 62.12-57.39 92.66 92.66 0 0 1 172.29-.92 49.47 49.47 0 0 1 51.55 13.32 34 34 0 0 1 52.1 28.85z"}));
}

CloudRight.defaultProps = {"viewBox":"0 0 1920 2800"};

module.exports = CloudRight;

CloudRight.default = CloudRight;
